import { StyleSheet } from 'react-native'
import Animated from 'react-native-reanimated'
import { LinearGradient } from 'expo-linear-gradient'
import cn from '@ui/utils/cn'
import { GradientProps as Props } from './types'

export default function Gradient({ className, style = {}, ...props }: Props) {
  return (
    <Animated.View
      className={cn(
        'absolute bottom-0 left-0 right-0 top-0 h-full w-full flex-1 overflow-hidden',
        className
      )}
      style={style}
    >
      <LinearGradient
        {...props}
        style={[
          StyleSheet.absoluteFill,
          // { top: 0, left: 0, right: 0, bottom: 0, flex: 1 },
        ]}
      />
    </Animated.View>
  )
}
